import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BooleanFormComponent } from './components/form-types/boolean/boolean-form.component';
import { DaterangeFormComponent } from './components/form-types/daterange/daterange-form.component';
import { DateFormComponent } from './components/form-types/date/date-form.component';
import { EnumFormComponent } from './components/form-types/enum/enum-form.component';
import { NumberFormComponent } from './components/form-types/number/number-form.component';
import { TextFormComponent } from './components/form-types/text/text-form.component';
import { TimeFormComponent } from './components/form-types/time/time-form.component';
import { FormTemplateComponent } from './components/form-template/form-template.component';
import { AutocompleteComponent } from './components/form-types/autocomplete/autocomplete.component';
import { NormalizedUnderscorePipe } from './pipes/normalized-underscore.pipe';
import { MatFormFieldModule, MatInputModule, MatDatepickerModule, MatSelectModule, MatButtonModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicFormBuilder } from './services/dynamic-form-builder.service';



@NgModule({
  declarations: [
    BooleanFormComponent,
    DateFormComponent,
    DaterangeFormComponent,
    EnumFormComponent,
    NumberFormComponent,
    TextFormComponent,
    TimeFormComponent,
    FormTemplateComponent,
    NormalizedUnderscorePipe,
    AutocompleteComponent,
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [DynamicFormBuilder],

  entryComponents: [
    BooleanFormComponent,
    DateFormComponent,
    DaterangeFormComponent,
    EnumFormComponent,
    NumberFormComponent,
    TextFormComponent,
    TimeFormComponent,
    AutocompleteComponent,
  ],

  exports: [FormTemplateComponent]
})
export class DynamicFormModule { }
